import { cn } from './cn'

/**
 * 24 小时柱状图。**手写 flex + 24 个 div，不引图表库**（CLAUDE.md §4.2）。
 *
 * 设计稿里就是这么做的，而且图表库在这儿一点忙都帮不上：没有坐标轴、没有图例、
 * 没有 tooltip、没有缩放。引一个进来只会为了 24 个矩形背上一个几十 KB 的依赖。
 *
 * 两个尺寸是设计稿的原值，没有对应 token（token 里的间距最小 6px，圆角最小 5px）：
 *   柱间 2px、柱高 40px、柱子圆角 2px（借 `--radius-npc-eye`，值正好是 2px）
 */
export interface BarsProps {
  /** 契约里 `MetricSeries.points`。缺数据的位置是 null，画成最矮的一根。 */
  points: { value: number | null }[]
  /** 最后几根画成主绿，表示「刚刚」。设计稿是 24 根里的最后 4 根。 */
  highlightLast?: number
  className?: string
}

/** 最矮也留一点，不然「这段时间没数据」看起来像图坏了。设计稿里下限是 40px 里的 8px。 */
const MIN_HEIGHT_PERCENT = 20

export function Bars({ points, highlightLast = 4, className }: BarsProps) {
  const firstHighlighted = points.length - highlightLast

  return (
    <div
      aria-hidden="true"
      className={cn('flex h-[40px] items-end gap-[2px]', className)}
    >
      {points.map((point, index) => {
        const value = point.value ?? 0
        const height = Math.max(MIN_HEIGHT_PERCENT, Math.min(100, value))
        return (
          <div
            key={index}
            style={{ height: `${height}%` }}
            className={cn(
              'flex-1 rounded-npc-eye',
              index >= firstHighlighted ? 'bg-npc-green' : 'bg-npc-chart-idle',
            )}
          />
        )
      })}
    </div>
  )
}
